module.exports = __webpack_public_path__ + "img/FYchFYZu8tuMAswsGAMtKC0TEjgyf.47200bee.jpg";